/* Router por hash. Mismas rutas que el prototipo:
   #/inicio · #/clientes[/:id[/:linea]] · #/proyectos[/:id] · #/jobs[/:id]
   #/ajustes · #/auditoria · #/memoria · #/bienvenida · #/onboarding · #/sin-acceso · #/login */

export type Ruta = { vista: string; a?: string; b?: string; q: Record<string, string> };

export function ruta(): Ruta {
  const [camino, consulta] = location.hash.replace(/^#\/?/, "").split("?");
  const partes = (camino || "").split("/").map(decodeURIComponent);
  const r: Ruta = { vista: partes[0] || "inicio", q: {} };
  if (partes[1]) r.a = partes[1];
  if (partes[2]) r.b = partes[2];
  new URLSearchParams(consulta || "").forEach((v, k) => { r.q[k] = v; });
  return r;
}

let alCambiar: (() => void) | null = null;
export function ir(hash: string) {
  if (location.hash === hash) alCambiar?.(); else location.hash = hash;
}
export function escuchar(fn: () => void) {
  alCambiar = fn;
  window.addEventListener("hashchange", fn);
}
